// Retry-After parsing for my-api's account-route 429 (rate-limit.ts
// AccountRouteLimiter). Its own module so the many test mocks of cognitoAuth
// never hide it.

/** Parse a Retry-After header in SECONDS (the only form my-api sends);
 *  anything else → undefined (the caller shows the plain copy). */
export function parseRetryAfter(raw: string | null | undefined): number | undefined {
  if (!raw || !/^\d+$/.test(raw.trim())) return undefined
  const n = Number(raw.trim())
  return n >= 1 && n <= 3600 ? n : undefined
}
